import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoChevronForward } from "react-icons/io5";

// Exact Image Imports from your data
import safariImg from "../assets/banner3.jpg";
import safariImg2 from "../assets/beans.jpg";
import safariImg3 from "../assets/banner1.jpg";
import safariImg4 from "../assets/serengeti.jpg";
import trekImg from "../assets/kilimanjaro.jpg";
import trekImg2 from "../assets/acc.jpg";
import trekImg3 from "../assets/beans.jpg";
import trekImg4 from "../assets/camp.jpg";
import zanzibarImg from "../assets/zanzibar1.jpg";
import zanzibarImg2 from "../assets/sunflower.jpg";
import zanzibarImg3 from "../assets/banner1.jpg";
import zanzibarImg4 from "../assets/banner5.jpg";

export default function ServicesBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  // Flattened and Mapped Itineraries from your dropdownContent
  const allItineraries = [
    // Safaris
    { title: "Luxury Safari", duration: "9 Days, 8 Nights", text: "Arusha to Serengeti, Ngorongoro Crater in premium lodges with Big Five.", img: safariImg, nav: { item: "services", subItem: "luxury" }, category: "Safaris" },
    { title: "Tanzania Safari", duration: "7 Days, 6 Nights", text: "Tarangire, Manyara, Serengeti, Crater - complete northern circuit.", img: safariImg2, nav: { item: "services", subItem: "migration" }, category: "Safaris" },
    { title: "Serengeti Wilderness", duration: "3 Days, 2 Nights", text: "Full game drives tracking Great Migration in endless plains.", img: safariImg4, nav: { item: "services", subItem: "serengeti" }, category: "Safaris" },
    // Trekking
    { title: "Machame Route", duration: "7 Days, 6 Nights", text: "Scenic route with strong acclimatization through rainforests to summit.", img: trekImg2, nav: { item: "services", subItem: "machame" }, category: "Trekking" },
    { title: "Lemosho Route", duration: "8 Days, 7 Nights", text: "High-scenic trail with varied terrain and excellent camp rhythm.", img: trekImg3, nav: { item: "services", subItem: "lemosho" }, category: "Trekking" },
    { title: "Rongai Route", duration: "7 Days, 6 Nights", text: "Quieter northern approach with broad mountain views to Kilimanjaro summit.", img: trekImg4, nav: { item: "services", subItem: "rongai" }, category: "Trekking" },
    // Zanzibar
    { title: "Zanzibar Experience", duration: "7 Days, 6 Nights", text: "Stone Town, Prison Island, Spice Farm, Safari Blue & Nungwi beaches.", img: zanzibarImg, nav: { item: "services", subItem: "stone-town" }, category: "Zanzibar" },
    { title: "Nungwi Beach", duration: "5 Days, 4 Nights", text: "Stone Town heritage + northern white sand beaches relaxation.", img: zanzibarImg4, nav: { item: "services", subItem: "nungwi" }, category: "Zanzibar" },
  ];

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return <div className="container py-5">{getInlineLoader()}</div>;
  }

  return (
    <section className="MainBodySection py-5" style={{ background: "#f8fafb" }}>
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="font-bold mb-2" style={{ color: "#132335", fontSize: "2.2rem" }}>
            Popular Itineraries
          </h2>
          <p style={{ color: "#546173" }}>Adventures for an unforgettable African experience</p>
        </div>

        <div className="row g-4">
          {allItineraries.map((trip, index) => (
            <div key={index} className="col-sm-6 col-lg-3">
              <div 
                className="itinerary-modern-card"
                data-aos="fade-up"
                data-aos-delay={index * 50}
                onClick={() => appContext.navTo(trip.nav)}
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  overflow: "hidden",
                  height: "100%",
                  boxShadow: "0 12px 24px rgba(0,0,0,0.04)",
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  transition: "transform 0.3s ease"
                }}
              >
                {/* Media Section */}
                <div style={{ height: "180px", position: "relative" }}>
                  <img 
                    src={trip.img} 
                    alt={trip.title} 
                    style={{ width: "100%", height: "100%", objectFit: "cover" }} 
                  />
                  <div style={{
                    position: "absolute",
                    bottom: "12px",
                    left: "12px",
                    background: "rgba(255,255,255,0.9)",
                    padding: "4px 10px",
                    borderRadius: "8px",
                    fontSize: "10px",
                    fontWeight: "700",
                    textTransform: "uppercase",
                    color: "#132335",
                    letterSpacing: "0.5px"
                  }}>
                    {trip.duration}
                  </div>
                </div>

                {/* Content Section */}
                <div style={{ padding: "20px", flexGrow: 1, display: "flex", flexDirection: "column" }}>
                  <span style={{ fontSize: "11px", fontWeight: "600", color: "#bb7a24", textTransform: "uppercase", marginBottom: "4px", display: "block" }}>
                    {trip.category}
                  </span>
                  <h5 className="font-bold mb-2" style={{ color: "#132335", fontSize: "1.1rem" }}>{trip.title}</h5>
                  <p style={{ color: "#6c757d", fontSize: "13.5px", lineHeight: "1.5", marginBottom: "20px" }}>
                    {trip.text}
                  </p>
                  
                  <div className="mt-auto">
                    <button 
                      className="btn btn-warning w-100 font-semi-bold d-flex align-items-center justify-content-center gap-2"
                      style={{ borderRadius: "10px", padding: "10px", fontSize: "14px" }}
                    >
                      View Trip <IoChevronForward size={14} />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}